
import { Options, mixins } from "vue-class-component";
import { RoutingUtilityMixin } from "@/mixins";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";

@Options({
  name: "BackButtonComponent",
  components: { SvgIcon },
})
export default class BackButtonComponent extends mixins(RoutingUtilityMixin) {
  protected goBack(): void {
    const currentRouteAsArray: string[] = [...this.$route.params.albumPath];

    currentRouteAsArray.pop();
    this.redirectToAlbum(currentRouteAsArray);
  }
}
